import { useState, useEffect, useCallback, useRef } from "react";

import { Client } from "../bitmaker/schemas/Billing/Client";

import { useApiError } from "./useApiError";

import { BitmakerAPIClient } from "../services/BitmakerApp";

export const useClients = () => {
  const [clients, setClients] = useState<Client[]>([]);
  const [loadingClients, setLoadingClients] = useState<boolean>(false);
  const [fetchClientsError, setFetchClientsError] = useState<string | null>(
    null,
  );

  const { handleAPIError } = useApiError();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchClients = useCallback(() => {
    if (!isMountedRef.current) return;

    setLoadingClients(true);
    setFetchClientsError(null);

    BitmakerAPIClient.get("/billing/clients", null, (response) => {
      if (!isMountedRef.current) return;

      const { isError, message } = handleAPIError(response);

      if (isError) {
        console.error("Error fetching clients:", message);
        setFetchClientsError("Error fetching clients. Please try again.");
        setLoadingClients(false);
        return;
      }

      const data = Array.isArray(response.data)
        ? (response.data as Client[])
        : [];
      setClients(data);

      setLoadingClients(false);
    });
  }, [handleAPIError]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  return {
    clients,
    loadingClients,
    fetchClientsError,
    refetchClients: fetchClients,
  };
};
